import { Newspaper } from '@phosphor-icons/react';
import { FeedPanel } from '@/components/feed/FeedPanel';

// FeedPage: vista global de actividad del equipo (ruta /feed). El cuerpo
// (filtros + lista con scroll infinito) vive en FeedPanel, reutilizado por el
// modal de Actividad de la campana del TopBar.
export function FeedPage() {
  return (
    <div className="h-full flex flex-col bg-brand-bg overflow-hidden">
      <div className="px-6 py-4 border-b border-stone-200 bg-white flex items-center gap-4">
        <h1 className="text-lg font-semibold text-stone-900 flex items-center gap-2">
          <Newspaper size={20} weight="bold" />
          Actividad del equipo
        </h1>
      </div>
      <div className="flex-1 overflow-hidden">
        <FeedPanel />
      </div>
    </div>
  );
}
